import { render, staticRenderFns } from "./DownApp.vue?vue&type=template&id=324bfe9f&scoped=true&"
import script from "./DownApp.vue?vue&type=script&lang=js&"
export * from "./DownApp.vue?vue&type=script&lang=js&"
import style0 from "./DownApp.vue?vue&type=style&index=0&id=324bfe9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bfe9f",
  null
  
)

export default component.exports